import siteConfig from "@/data/site-config.json";
import { siteConfigSchema } from "@/schemas/site-config";
import type { LandingConfig, NavItem, SiteConfig } from "@/types/site-config";

export interface SiteConfigRepository {
  getSiteConfig(): SiteConfig;
  getLandingConfig(): LandingConfig;
  getNavigation(): NavItem[];
}

class JsonSiteConfigRepository implements SiteConfigRepository {
  private readonly data = siteConfigSchema.parse(siteConfig);

  getSiteConfig() {
    return this.data;
  }

  getLandingConfig() {
    return this.data.landing;
  }

  getNavigation() {
    return this.data.navigation;
  }
}

export const siteConfigRepository: SiteConfigRepository = new JsonSiteConfigRepository();
